export default "__VITE_ASSET__DtfWTr1t__"